export type CreationDatePresetKey = 'today' | '7d' | '30d' | 'month';

export const CREATION_DATE_FILTERS: { key: CreationDatePresetKey; label: string }[] = [
  { key: 'today', label: 'Hoje' },
  { key: '7d', label: 'Últimos 7 dias' },
  { key: '30d', label: 'Últimos 30 dias' },
  { key: 'month', label: 'Este mês' },
];

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const formatPickerDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getPresetCutoffDate = (key: CreationDatePresetKey): Date => {
  const todayStart = startOfDay(new Date());
  switch (key) {
    case 'today':
      return todayStart;
    case '7d': {
      const cutoff = new Date(todayStart);
      cutoff.setDate(cutoff.getDate() - 6);
      return cutoff;
    }
    case '30d': {
      const cutoff = new Date(todayStart);
      cutoff.setDate(cutoff.getDate() - 29);
      return cutoff;
    }
    case 'month':
      return new Date(todayStart.getFullYear(), todayStart.getMonth(), 1);
    default:
      return todayStart;
  }
};

export const presetCutoffPickerValue = (key: CreationDatePresetKey): string =>
  formatPickerDate(getPresetCutoffDate(key));

export const parseCreatedAt = (iso?: string | null): Date | null => {
  if (!iso) return null;
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const parsePickerDate = (value: string): Date | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]) - 1;
  const day = Number(match[3]);
  const parsed = new Date(year, month, day);
  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month ||
    parsed.getDate() !== day
  ) {
    return null;
  }
  return startOfDay(parsed);
};

/** Keep records created on or after the picker date; exclude older. */
export const matchesCreationDateFrom = (createdAtIso: string | undefined | null, dateFrom: string): boolean => {
  if (!dateFrom.trim()) return true;
  const cutoff = parsePickerDate(dateFrom);
  if (!cutoff) return true;

  const created = parseCreatedAt(createdAtIso);
  if (!created) return false;

  return created >= cutoff;
};
